import {PanelHeader} from './PanelHeader';

interface CpPageProps {
  children?: React.ReactNode;
  title?: string;
  top_right_component?: string;
}

export const CpPage = (props: CpPageProps) => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <PanelHeader title={props.title} />

      {/* Page content */}
      <main style={{
        maxWidth: '983px',
        margin: '0 auto',
        padding: '24px',
      }}>
        {props.children}
      </main>
    </div>
  );
};
